module.exports = __webpack_public_path__ + "img/minimize-01.a88ded0a.svg";